import { createSlice } from '@reduxjs/toolkit';

// types
import { LoaderProps } from 'types/loader';

const initialState: LoaderProps = {
    byId: {}, // e.g. { form: { visible:true, color:'primary', type:'form', autoHideMs: 0 }, ... }
    action: false,
    loaderVisible: false,
    loaderColor: 'primary',
    loaderType: 'form',
    autoHideLoaderDuration: 5000
};

// ==============================|| SLICE - SNACKBAR ||============================== //

const loader = createSlice({
    name: 'loader',
    initialState,
    reducers: {
        
        showLoader (state)  {
            
            state.action = !state.action;
            state.loaderVisible = true;
            state.loaderColor = initialState.loaderColor;
            state.loaderType = initialState.loaderType;
            state.autoHideLoaderDuration = initialState.autoHideLoaderDuration;
            
    },
    showLoaderById (state, { payload })  {
        const {
            id,                    // e.g. 'form', 'table', 'saveBtn'
            color = 'primary',
            type = id,             // keep type same as id by default
            autoHideMs = 0
          } = payload;
          
          if(state.byId){
          state.byId[id] = {
            visible: true,
            color,
            type,
            autoHideMs
          };
        }
        if (initialState.loaderType === id)  { 
         state.action = !state.action;
         state.loaderVisible = true;
         state.loaderColor = initialState.loaderColor;
         state.loaderType = initialState.loaderType;
         state.autoHideLoaderDuration = initialState.autoHideLoaderDuration;
        }
        
},
        hideLoader(state) {
            const id = state.loaderType;
            if (id && state.byId && state.byId[id]) state.byId[id].visible = false;
            state.loaderVisible = false;
            
        },
        hideLoaderById(state, { payload }) {
            const { id } = payload;
            if (state.byId && state.byId[id]) state.byId[id].visible = false;
            if (state.loaderType === id)  { 
                state.loaderVisible = false;
            }
        },
        // hide everything at once
    hideAll(state) {
        if(state.byId){
        Object.keys(state.byId).forEach(k => { 
            if(state.byId && state.byId[k]) {
            state.byId[k].visible = false; 
            }
        });
        }
        state.loaderVisible = false;
      }
    }
});

export default loader.reducer;

export const { hideLoader,hideLoaderById, showLoader,showLoaderById, hideAll} = loader.actions;

// Selectors
export const selectLoader = (id:any) => (s:any) => s.loader.byId[id] || { visible: false };
export const selectAnyLoading = (s:any) => Object.values(s.loader.byId).some((x:any) => x?.visible);